import moment, { urlFormat } from 'helpers/moment'
import { sortBy } from 'lodash'

export const stateOptions = []

const states = { 'AL': 'ALABAMA', 'AK': 'ALASKA', 'AZ': 'ARIZONA', 'AR': 'ARKANSAS', 'CA': 'CALIFORNIA', 'CO': 'COLORADO', 'CT': 'CONNECTICUT', 'DE': 'DELAWARE', 'DC': 'DISTRICT OF COLUMBIA', 'FL': 'FLORIDA', 'GA': 'GEORGIA', 'HI': 'HAWAII', 'ID': 'IDAHO', 'IL': 'ILLINOIS', 'IN': 'INDIANA', 'IA': 'IOWA', 'KS': 'KANSAS', 'KY': 'KENTUCKY', 'LA': 'LOUISIANA', 'ME': 'MAINE', 'MD': 'MARYLAND', 'MA': 'MASSACHUSETTS', 'MI': 'MICHIGAN', 'MN': 'MINNESOTA', 'MS': 'MISSISSIPPI', 'MO': 'MISSOURI', 'MT': 'MONTANA', 'NE': 'NEBRASKA', 'NV': 'NEVADA', 'NH': 'NEW HAMPSHIRE', 'NJ': 'NEW JERSEY', 'NM': 'NEW MEXICO', 'NY': 'NEW YORK', 'NC': 'NORTH CAROLINA', 'ND': 'NORTH DAKOTA', 'OH': 'OHIO', 'OK': 'OKLAHOMA', 'OR': 'OREGON', 'PA': 'PENNSYLVANIA', 'RI': 'RHODE ISLAND', 'SC': 'SOUTH CAROLINA', 'SD': 'SOUTH DAKOTA', 'TN': 'TENNESSEE', 'TX': 'TEXAS', 'UT': 'UTAH', 'VT': 'VERMONT', 'VA': 'VIRGINIA', 'WA': 'WASHINGTON', 'WV': 'WEST VIRGINIA', 'WI': 'WISCONSIN', 'WY': 'WYOMING' } // eslint-disable-line max-len

for (const key in states) {
  stateOptions.push({
    value: key,
    label: states[key].toLowerCase()
      .replace(/(^|\s)[a-z]/g, (f) => f.toUpperCase())  // capitalize each word
      .replace('Of', 'of') // prettier
  })
}

// sort = sort function, true to sort by label, or false for no sorting
export const makeOptions = (list, id = 'id', label = 'name', { sort = true, disabled, enabled } = {}) => {
  if (!list || !list.length) return []

  list = list.slice()
  list = list.filter(item => item[id] !== undefined && item[label] !== undefined)

  // sort by label (localeCompare sorts unicode and uppercase/numbers properly)
  if (sort === true) sort = (a, b) => a[label].localeCompare(b[label])

  if (typeof sort === 'function') {
    list = list.sort(sort) // es6 sorting
  } else if (sort) {
    list = sortBy(list, sort) // accepts array, string
  }

  const isDisabled = (item) => {
    if (!disabled && !enabled) return false

    if (typeof disabled === 'string' && item[disabled] !== undefined) return item[disabled]
    else if (typeof disabled === 'function') return disabled(item)

    // if enabled, disabled = !enabled
    if (typeof enabled === 'string' && item[enabled] !== undefined) return !item[enabled]
    else if (typeof enabled === 'function') return !enabled(item)
    return false
  }

  return list.map((item) => {
    return {
      value: item[id],
      label: item[label],
      model: item,
      disabled: isDisabled(item)
    }
  })
}

export const timezoneOptions = [
  { value: 'America/Los_Angeles', label: 'Los Angeles' },
  { value: 'America/Phoenix', label: 'Phoenix' },
  { value: 'America/Denver', label: 'Denver' },
  { value: 'America/Chicago', label: 'Chicago' },
  { value: 'America/New_York', label: 'New York' },
  { value: 'Pacific/Honolulu', label: 'Honolulu' },
  { value: 'America/Anchorage', label: 'Anchorage' },
  { value: 'UTC', label: 'UTC' }
]

export const rolloverOptions = (() => {
  let a = []
  let hours = 24
  for (let i = 0; i < hours; i++) {
    const value = -i
    // 23 - 2 - 12 + pm = 9pm
    let label = ((hours - i) - (i >= 12 ? 0 : 12)) + (i >= 12 ? 'am' : 'pm')
    if (i === 0 || i === 24) label = 'midnight'
    if (i === 12) label = 'noon'
    a.push({ value, label })
  }
  return a
})()

export const formatCityState = (city, state) => {
  if (!city && !state) return null

  if (!state) return city
  if (!city) return state

  return `${city}, ${state}`
}

export const createNewPath = (
  date = 'today',
  base = 'orders',
  { location = {}, params = {} } = {}, // props
  { append = '', action, id } = {} // options
) => {
  date = moment(date).format(urlFormat)
  base = `/${base}`
  id = id || params.id // get id from url route if necessary

  if (!action && location && location.pathname) {
    if (location.pathname.includes('/edit')) action = 'edit'
    else if (location.pathname.includes('/new')) action = 'new'
    else if (location.pathname.includes('/list')) action = 'list'
  }

  let path
  switch (action) {
    case 'edit':
      if (!id) throw new Error('Unable to create an edit path without an id.')
      path = `${base}/${id}/edit`
      break
    case 'new':
      path = `${base}/${date}/new`
      break
    case 'list':
      path = `${base}/${date}/list`
      break
    default:
      path = `${base}/${date}`
  }

  if (append) path += `/${append}` // appends whatever onto the end
  path = path.replace(/\/+$/g, '') // remove trailing slashes
  path = path.replace(/\/{2,}/g, '/') // replace 2+ forward slashes in a row

  return path
}



// WEBPACK FOOTER //
// ./src/helpers/components.js